import { render, staticRenderFns } from "./SummaryAccessoryModal.vue?vue&type=template&id=241ce060&"
import script from "./SummaryAccessoryModal.vue?vue&type=script&lang=js&"
export * from "./SummaryAccessoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports